import type { TrackingConfig, TrackingItem, SubCategory } from '@/models/TrackingConfig';
export const trackingConfig: TrackingConfig = {
  home: {},
  sale: {
    buttons: {
      multiPortalPublishing: {
        dataTrackingId: 'btn-multi-portal-publishing-1',
        dataPage: 'sale',
      }
    },
    elements: {
      multiPortalPublishing: {
        dataTrackingId: 'multi-portal-publishing-1',
        dataPage: 'sale',
      }
    },
  },
  search: {
    buttons: {
      shoutOutRegisterNow: {
        dataTrackingId: [
          'registrierungsbox_variante_1',
          'registrierungsbox_variante_2',
          'registrierungsbox_variante_3',
          'registrierungsbox_variante_4',
          'registrierungsbox_variante_5',
        ],
        dataPage: 'search',
      },
      shoutOutActivateSubscription: {
        dataTrackingId: [
          'btn-activate-subscription-1',
        ],
        dataPage: 'search',
      },
      shoutOutDiscount: {
        dataTrackingId: [
          'btn-discount-1',
        ],
        dataPage: 'search',
      },
      conversionModalUnregistered: {
        dataTrackingId: [
          'modal-contact-registration-trustpilot-1',
          'modal-watchlist-registration-trustpilot-1',
          'modal-report-registration-trustpilot-1'
        ],
        dataPage: 'search',
      },
      searchFunctionWatchlistUnregistered: {
        dataTrackingId: 'btn-search-function-watchlist-1',
        dataPage: 'search',
      },
      searchFunctionComplaintUnregistered: {
        dataTrackingId: 'btn-search-function-complaint-1',
        dataPage: 'search',
      },
      shareOffer: {
        dataTrackingId: [
          'share-link-1',
          'share-email-1',
          'share-messages-1',
          'share-whatsApp-1',
          'share-facebookMessenger-1',
          'share-facebook-1',

        ],
        dataPage: 'search',
      }
    },
    elements: {
      shoutOutRegisterNow: {
        dataTrackingId: [
          'registrierungsbox_variante_1',
          'registrierungsbox_variante_2',
          'registrierungsbox_variante_3',
          'registrierungsbox_variante_4',
          'registrierungsbox_variante_5',
          'registrierungsbox_variante_5_2',
          'registrierungsbox_variante_5_3',
        ],
        dataPage: 'search',
      },
      shoutOutActivateSubscription: {
        dataTrackingId: [
          'probox_variante_1',
          'probox_variante_2',
          'probox_variante_3',
        ],
        dataPage: 'search',
      },
      shoutOutDiscount: {
        dataTrackingId: [
          'discountbox_variante_1',
          'discountbox_variante_2',
          'discountbox_variante_3',
          'discountbox_variante_3_2',
          'discountbox_variante_3_3',
          'discountbox_variante_4',
        ],
        dataPage: 'search',
      },
      conversionModalUnregistered: {
        dataTrackingId: [
          'modal-contact-registration-trustpilot-1',
          'modal-watchlist-registration-trustpilot-1',
          'modal-report-registration-trustpilot-1'
        ],
          dataPage: 'search',
      },
      shareOffer: {
        dataTrackingId: 'share-offer-1',
        dataPage: 'search',
      }
    },
  },
  matches: {
    buttons: {
      completeProfile: {
        dataTrackingId: [
          'btn-complete-profile-1',
          'btn-complete-profile-2',
        ],
        dataPage: 'matches',
      },
      increaseResponseRate: {
        dataTrackingId: 'btn-increase-response-rate-1',
        dataPage: 'matches',
      },
      shareOffer: {
        dataTrackingId: [
          'share-link-1',
          'share-email-1',
          'share-messages-1',
          'share-whatsApp-1',
          'share-facebookMessenger-1',
          'share-facebook-1',

        ],
        dataPage: 'matches',
      },
      shoutOutDiscount: {
        dataTrackingId: [
          'btn-discount-1',
        ],
        dataPage: 'matches',
      },
    },
    elements: {
      shareOffer: {
        dataTrackingId: 'share-offer-1',
        dataPage: 'matches',
      },
      shoutOutDiscount: {
        dataTrackingId: [
          'discountbox_variante_1',
          'discountbox_variante_2',
          'discountbox_variante_3',
          'discountbox_variante_3_2',
          'discountbox_variante_3_3',
          'discountbox_variante_4',
        ],
        dataPage: 'matches',
      },
    }
  },
  ad: {
    buttons: {
      map: {
        dataTrackingId: 'btn-map-registration-1',
        dataPage: 'ad',
      },
      imageGallery: {
        dataTrackingId: 'btn-image-gallery-registration-1',
        dataPage: 'ad',
      },
      registrationBox: {
        dataTrackingId: 'registration-box',
        dataPage: 'ad',
      },
      contactFunction: {
        dataTrackingId: 'btn-contact-1',
        dataPage: 'ad',
      },
      watchFunction: {
        dataTrackingId: 'btn-watch-1',
        dataPage: 'ad',
      },
      conversionModalUnregistered: {
        dataTrackingId: [
          'modal-contact-registration-trustpilot-1',
          'modal-watchlist-registration-trustpilot-1',
          'modal-report-registration-trustpilot-1'
        ],
        dataPage: 'ad',
      },
      shareOffer: {
        dataTrackingId: [
          'share-link-1',
          'share-email-1',
          'share-messages-1',
          'share-whatsApp-1',
          'share-facebookMessenger-1',
          'share-facebook-1',

        ],
        dataPage: 'ad',
      }
    },
    elements: {
      registrationBox: {
        dataTrackingId: 'registration-box',
        dataPage: 'ad',
      },
      similarHousing: {
        dataTrackingId: 'similar-housing-pos-',
        dataPage: 'ad',
      },
      conversionModalUnregistered: {
        dataTrackingId: [
          'modal-contact-registration-trustpilot-1',
          'modal-watchlist-registration-trustpilot-1',
          'modal-report-registration-trustpilot-1'
        ],
        dataPage: 'ad',
      },
      shareOffer: {
        dataTrackingId: 'share-offer-1',
        dataPage: 'ad',
      }
    },
  },
  testimonial: {},
  prices: {},
  chat: {
    buttons: {
      increaseResponseRate: {
        dataTrackingId: 'btn-increase-response-rate-1',
        dataPage: 'chat',
      },
      conversionBox: {
        dataTrackingId: 'btn-chat-conversion-1',
        dataPage: 'chat',
      }
    },
    elements: {
      conversionBox: {
        dataTrackingId: 'chat-conversion-box-1',
        dataPage: 'chat',
      }
    },
  },
  account: {
    buttons: {
      completeProfile: {
        dataTrackingId: [
          'btn-complete-profile-1',
          'btn-complete-profile-2',
        ],
        dataPage: 'account',
      }
    }
  },
  advancedNavigation: {},
};

const defaultTrackingItem: TrackingItem = {
  dataTrackingId: 'fallback-id',
  dataPage: 'fallback-page',
};

export function useTrackingConfig() {
  /**
   * @param page Seitenkategorie, z.B. 'ad'
   * @param subCategory z.B. 'buttons' oder 'elements'
   * @param area Key im jeweiligen Objekt, z.B. 'map'
   */
  const getTrackingConfig = (
    page: keyof TrackingConfig,
    subCategory: SubCategory,
    area: string
  ): TrackingItem => {

    const categoryConfig = trackingConfig[page];
    if (!categoryConfig) {
      console.warn(`Category "${String(page)}" not found in trackingConfig.`);

      return defaultTrackingItem;
    }

    const subConfig = categoryConfig[subCategory];
    if (!subConfig) {
      console.warn(
        `SubCategory "${subCategory}" not found in category "${String(page)}".`
      );
      return defaultTrackingItem;
    }

    const config = subConfig[area];
    if (!config) {
      console.warn(
        `Area "${area}" not found in subCategory "${subCategory}" of category "${String(page)}".`
      );
      return defaultTrackingItem;
    }

    return config;
  };

  return {
    getTrackingConfig,
  };
}
